"use client"

import { NpButton } from "src/components/np-design/components/button/NpButton"
import { routes } from "src/config/routes"
import { getProductAvailable } from "src/data/product-list/mapping"
import { ListProductData } from "src/data/product-list/types"
import { useEventCallback } from "src/hooks/useEventCallback"
import { trackProductLinkClick, useTrackViewPromotion } from "src/tracking/events"

export type ProductPrimaryLinkProps = {
  listId: string
  product: ListProductData
}

export const ProductPrimaryLink = ({ listId, product }: ProductPrimaryLinkProps) => {
  const ref = useTrackViewPromotion(product)
  const onClick = useEventCallback(() => trackProductLinkClick(listId, product))

  if (!product.slug) {
    return null
  }

  const href = routes.formatProduct(product.slug)
  const available = getProductAvailable(product)

  return (
    <NpButton
      ref={ref}
      href={href}
      color={available ? "green" : "gray75"}
      iconNameRight="arrow_forward"
      title={available ? undefined : "Derzeit nicht verfügbar"}
      onClick={onClick}
    >
      <div className="flex flex-col items-center">
        <div>Ansehen</div>
        {!available && <div className="text-xs">(Derzeit nicht verfügbar)</div>}
      </div>
    </NpButton>
  )
}
